<template>
    <div>
        <form id="contact-form" @submit.prevent="proceed">
            <div class="cf-field">
                <label class="cf-label">Your Name</label>
                <input type="text" class="cf-input" name="name" placeholder="John Doe" required v-model="contact.name">
            </div>
            <div class="cf-field">
                <label class="cf-label">Email Address</label>
                <input type="email" class="cf-input" name="email" placeholder="john@example.com" required v-model="contact.email">
            </div>
            <div class="cf-field">
                <label class="cf-label">How can we help?</label>
                <textarea class="cf-input cf-textarea" name="message" placeholder="Tell us what's on your mind…" required v-model="contact.message"></textarea>
            </div>
            <button type="submit" class="cf-submit">
                <ion-icon name="send-outline"></ion-icon>
                Send Message
            </button>
        </form>
        <post-contact-message/>
    </div>
</template>

<script>
import Contact from '../models/contact';
import methodsMixin from '../utils/methodsMixin';
import postContactMessage from './modals/home/postContactMessage2';

export default {
    name: 'contactForm',
    data(){
        return {
            contact: new Contact().data
        }
    },
    mixins: [methodsMixin],
    methods: {
        async proceed(){
            if(!this.contact.name || !this.contact.email || !this.contact.message){
                return alert('Please complete all fields');
            }
            if(!this.validateEmail(this.contact.email)){
                return alert('Enter a valid email address');
            }
            this.$loader.show();
            const response = await this.$store.dispatch('contact/addContact', this.contact);
            this.$loader.hide();
            if(response.status){
                $('#postContactMSG').modal('show');
                this.contact = new Contact().data;
            }else{
                return alert(response.message);
            }
        }
    },
    components: { postContactMessage },
};
</script>

<style scoped>
.cf-field {
    margin-bottom: 20px;
}
.cf-label {
    display: block;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.5);
    margin-bottom: 8px;
}
.cf-input {
    width: 100%;
    background: rgba(255,255,255,0.05);
    border: 1.5px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 14px;
    color: #fff;
    font-family: inherit;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
    -webkit-appearance: none;
    appearance: none;
}
.cf-input::placeholder {
    color: rgba(255,255,255,0.25);
}
.cf-input:focus {
    border-color: rgba(115,97,76,0.6);
    box-shadow: 0 0 0 3px rgba(115,97,76,0.12);
    background: rgba(255,255,255,0.07);
}
.cf-textarea {
    min-height: 130px;
    resize: vertical;
}
.cf-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 16px;
    background: var(--theme-primary-500, #73614C);
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.01em;
    cursor: pointer;
    transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
    margin-top: 8px;
    font-family: inherit;
}
.cf-submit ion-icon {
    font-size: 18px;
}
.cf-submit:hover {
    background: var(--theme-primary-700, #2A1F13);
    box-shadow: 0 6px 20px rgba(115,97,76,0.35);
    transform: translateY(-1px);
}
.cf-submit:active {
    transform: translateY(0);
}
</style>
